import { z } from 'zod'

export const twoFaVerifySchema = z.object({
  code: z.string().min(1, 'Zadajte prosím platný kód'),
})

export type TwoFaVerifySchema = z.infer<typeof twoFaVerifySchema>
